/**
 * 资源加载模块
 * @param {object} kaplay - KAPLAY引擎实例
 */
export function loadAssets(kaplay) {
    const { loadRoot, loadSprite } = kaplay;

    // 设置资源根目录
    loadRoot('./');

    // 加载所有游戏精灵资源
    loadSprite('bg', 'bg.jpg');
    loadSprite('catL', 'cat L.png');
    loadSprite('catR', 'cat R.png');
    loadSprite('catPlay', 'cat play.png');
    loadSprite('catTeaser', 'cat teaser.png');
    loadSprite('cat', 'cat.png');
    loadSprite('hand', 'hand.png');
    loadSprite('swipeL', 'swipe L.png');
    loadSprite('swipeR', 'swipe R.png');
    loadSprite('textBg', 'text_bg.png');
    loadSprite('touch1', 'touch1.png');
}
